import Box from '@mui/material/Box';
import { values } from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Hidden, useMediaQuery } from '@mui/material';

import { Container, Col } from '../grid';
import Row from '../grid/row';
import { SPACE, RATERS, BREAKPOINTS, COLORS } from '../../constants';
import { SHOW_ECO_DATA } from '../../constants/flags';
import { BODY_STYLES } from '../../constants/body-styles';
import { convertToCurrencyFormat } from '../../utils/convert-to-currency-format';
import { ExtraSmall, Small } from '../type';
import { P_PLATE_RESTRICTION_STATUSES } from '../../constants/statuses';
import { PrimaryButton } from '../button';
import CardImage from '../card-image';
import CompareCarIcon from '../icons/compare-car-icon';
import PPlateRestrictionStatus from '../p-plate-restriction-status';
import SafetyRow from '../safety-row/index';
import StarRating from '../star-rating';
import { logTrackingEvent } from '../../utils/tracking';
import getIsZeroStarAncapRating from '../../utils/get-is-zero-star-ancap-rating';
import { STAR_PLACEMENT } from '../star-rating/constants';

import { tooltipCopy } from './tooltip-copy';
import { Divider, StarRatingWrapper, ScorecardWrapper } from './styles';

import SaferPickBanner from './components/safer-pick-banner';
import SafetyAtAGlanceContent from './components/safety-at-a-glance-content';
import EfficiencyAtAGlanceContent from './components/efficiency-at-a-glance-content';
import { StyledTab, StyledTabs, TabsWrapper } from '../search/styles';
import styled from '@emotion/styled';

const SCORECARD_TABS = {
  SAFETY: 0,
  EFFICIENCY: 1,
};

const ANCAP_ORIGINAL_PDF =
  'https://s3.amazonaws.com/cdn.ancap.com.au/app/public/assets/317f48df35bf6d0685ca9dddb6e9646260bfac4c/original.pdf?1614563288';

const SecondColumnToFillRow = styled(Col)`
  /* These are in a special selector to have a higher priority over existing MUI styles */
  &.MuiGrid-root {
    max-width: unset;
    flex-grow: 1;
  }

  border: 2px solid ${COLORS.GREY_FOUR};
  padding: 0;
`;

const Scorecard = ({
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'actions' implicitly has an 'any' type.
  actions,
  vehicleDetails = null,
  scorecardBaseItems = null,
  ancapTestResults = null,
  ucsrTestResults = null,
  shouldUsePedestrianProtection = false,
  footer = null,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'vehicleEcoData' implicitly has an 'any' type.
  vehicleEcoData,
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'pageVehicle' implicitly has an 'any' type.
  pageVehicle,
}) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'image' does not exist on type 'null'.
  const { image, ratingProvider, redbookCode, stars, yearTested } = vehicleDetails;
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'bodyStyle' does not exist on type 'null'.
  const { bodyStyle, recommendedSafetyFeaturesCount } = scorecardBaseItems;
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'ancapReport' does not exist on type 'null'.
  const { ancapReport } = ancapTestResults;
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'saferPick' does not exist on type 'null'.
  const { saferPick } = ucsrTestResults;
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'newPrice' does not exist on type 'null'.
  const { newPrice, priceRange, pPlateRestrictions } = footer;

  const [selectedTab, setSelectedTab] = useState(SCORECARD_TABS.SAFETY);
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter '_' implicitly has an 'any' type.
  const onSelectedTabChange = (_, newSelectedTab) => setSelectedTab(newSelectedTab);

  const nonRatingItems = [
    {
      id: 1,
      label: 'Recommended Safety Features',
      feature: `${recommendedSafetyFeaturesCount.vehicle}/${recommendedSafetyFeaturesCount.total}`,
      tooltip: tooltipCopy.recommendedSafetyFeatures,
    },
    {
      id: 2,
      label: 'Body type',
      feature: bodyStyle.label,
      tooltip: null,
    },
  ];

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Argument of type 'null' is not assignable to parameter of type '{ makeDescription: any; modelDescription: any; year: any; }'.
  const isZeroStarAncapRating = getIsZeroStarAncapRating(vehicleDetails);
  const ancapReportDownloadLink = isZeroStarAncapRating && !ancapReport ? ANCAP_ORIGINAL_PDF : ancapReport;
  const smUp = useMediaQuery(`(min-width: ${BREAKPOINTS.SM}px)`);
  const smUpSpacing = !smUp ? 0 : undefined;

  return (
    <ScorecardWrapper>
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Element[]; }' is missing the following properties from type '{ [x: string]: any; className: any; maxWidth: any; children: any; }': className, maxWidth */}
      <Container>
        {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'className' is missing in type '{ children: Element[]; spacing: number | undefined; mb: number; }' but required in type '{ [x: string]: any; className: any; children: any; spacing: any; }'. */}
        <Row spacing={smUpSpacing} mb={6}>
          {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Element[]; spacing: number | undefined; sm: number; lg: number; p: number; pr: number; }' is missing the following properties from type '{ [x: string]: any; className: any; offset: any; width: any; }': className, offset, width */}
          <Col spacing={smUpSpacing} sm={4} lg={4} p={0} pr={4}>
            <Box marginBottom={SPACE.X1}>
              <CardImage src={image.src} alt={image.alt} />
            </Box>
            <StarRatingWrapper>
              <StarRating
                stars={stars}
                ratingBy={ratingProvider}
                testYear={yearTested}
                placement={STAR_PLACEMENT.SCORECARD}
                forceZeroStars={isZeroStarAncapRating}
              />
              {ratingProvider === RATERS.NO_CURRENT_RATING && <Small>No current rating</Small>}
              {ratingProvider === RATERS.NO_RATING && <Small>Not rated</Small>}
            </StarRatingWrapper>
            <Hidden smUp>
              <SaferPickBanner isSaferPick={saferPick} ratingProvider={ratingProvider} />
            </Hidden>
          </Col>
          {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: (false | Element)[]; spacing: number | undefined; sm: number; lg: number; }' is missing the following properties from type '{ [x: string]: any; className: any; offset: any; width: any; }': className, offset, width */}
          <SecondColumnToFillRow spacing={smUpSpacing} sm={8} lg={6}>
            {SHOW_ECO_DATA && (
              <TabsWrapper>
                <StyledTabs value={selectedTab} onChange={onSelectedTabChange}>
                  <StyledTab label="Safety at a glance" />
                  <StyledTab label="Efficiency at a glance" />
                </StyledTabs>
              </TabsWrapper>
            )}
            {selectedTab === SCORECARD_TABS.SAFETY && (
              <SafetyAtAGlanceContent
                ratingProvider={ratingProvider}
                ancapTestResults={ancapTestResults}
                ucsrTestResults={ucsrTestResults}
                shouldUsePedestrianProtection={shouldUsePedestrianProtection}
                saferPick={saferPick}
                nonRatingItems={nonRatingItems}
                ancapReportDownloadLink={ancapReportDownloadLink}
              />
            )}
            {selectedTab === SCORECARD_TABS.EFFICIENCY && (
              <EfficiencyAtAGlanceContent vehicleEcoData={vehicleEcoData} pageVehicle={pageVehicle} />
            )}
          </SecondColumnToFillRow>
        </Row>
        <Divider />
        {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'className' is missing in type '{ children: Element[]; spacing: number | undefined; }' but required in type '{ [x: string]: any; className: any; children: any; spacing: any; }'. */}
        <Row spacing={smUpSpacing}>
          {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Element[]; spacing: number | undefined; xs: number; sm: number; lg: number; offset: number[]; }' is missing the following properties from type '{ [x: string]: any; className: any; offset: any; width: any; }': className, width */}
          <Col spacing={smUpSpacing} xs={6} sm={4} lg={3} offset={[0, 0, 0, 1 / 12]}>
            <ExtraSmall as="h4">P-plater restrictions</ExtraSmall>
            <PPlateRestrictionStatus pPlateRestrictionStatus={pPlateRestrictions} />
          </Col>
          <Hidden smUp>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Element; spacing: number | undefined; xs: number; }' is missing the following properties from type '{ [x: string]: any; className: any; offset: any; width: any; }': className, offset, width */}
            <Col spacing={smUpSpacing} xs={6}>
              {priceRange.low && priceRange.high ? (
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ label: string; feature: string; }' is missing the following properties from type '{ label: any; feature: any; tooltip: any; starColor: any; maxStars: any; starAriaDescription: any; }': tooltip, starColor, maxStars, starAriaDescription
                <SafetyRow
                  label="Private price guide"
                  feature={`$${convertToCurrencyFormat(priceRange.low)} - $${convertToCurrencyFormat(priceRange.high)}`}
                />
              ) : (
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ label: string; feature: string; }' is missing the following properties from type '{ label: any; feature: any; tooltip: any; starColor: any; maxStars: any; starAriaDescription: any; }': tooltip, starColor, maxStars, starAriaDescription
                <SafetyRow
                  label="Price guide"
                  feature={newPrice ? `$${convertToCurrencyFormat(newPrice)}` : 'Pricing unavailable'}
                />
              )}
            </Col>
          </Hidden>
          {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Element[]; spacing: number | undefined; container: true; sm: number; lg: number; offset: number[]; }' is missing the following properties from type '{ [x: string]: any; className: any; offset: any; width: any; }': className, width */}
          <Col spacing={smUpSpacing} container sm={8} lg={6} offset={[0, 0, 0, 1 / 12]}>
            <Hidden smDown>
              {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Element; spacing: number; xs: number; }' is missing the following properties from type '{ [x: string]: any; className: any; offset: any; width: any; }': className, offset, width */}
              <Col spacing={0} xs={6}>
                {priceRange.low && priceRange.high ? (
                  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ label: string; feature: string; }' is missing the following properties from type '{ label: any; feature: any; tooltip: any; starColor: any; maxStars: any; starAriaDescription: any; }': tooltip, starColor, maxStars, starAriaDescription
                  <SafetyRow
                    label="Private price guide"
                    feature={`$${convertToCurrencyFormat(priceRange.low)} - $${convertToCurrencyFormat(
                      priceRange.high
                    )}`}
                  />
                ) : (
                  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ label: string; feature: string; }' is missing the following properties from type '{ label: any; feature: any; tooltip: any; starColor: any; maxStars: any; starAriaDescription: any; }': tooltip, starColor, maxStars, starAriaDescription
                  <SafetyRow
                    label="Price guide"
                    feature={newPrice ? `$${convertToCurrencyFormat(newPrice)}` : 'Pricing unavailable'}
                  />
                )}
              </Col>
            </Hidden>
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Element; spacing: number | undefined; xs: number; sm: number; }' is missing the following properties from type '{ [x: string]: any; className: any; offset: any; width: any; }': className, offset, width */}
            <Col spacing={smUpSpacing} xs={12} sm={5}>
              <Box mt={{ xs: SPACE.X1, sm: 0 }}>
                <PrimaryButton
                  fullWidth
                  startIcon={<CompareCarIcon />}
                  onClick={() => {
                    actions.addToCompare(redbookCode);
                    actions.openMiniCart();
                    logTrackingEvent({
                      event: 'addToCompare',
                    });
                  }}
                >
                  Compare
                </PrimaryButton>
              </Box>
            </Col>
          </Col>
        </Row>
      </Container>
    </ScorecardWrapper>
  );
};

Scorecard.propTypes = {
  actions: PropTypes.shape({
    addToCompare: PropTypes.func.isRequired,
    openMiniCart: PropTypes.func.isRequired,
  }).isRequired,
  vehicleDetails: PropTypes.shape({
    image: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    }),
    ratingProvider: PropTypes.string,
    redbookCode: PropTypes.string.isRequired,
    stars: PropTypes.number,
    yearTested: PropTypes.number,
  }),
  scorecardBaseItems: PropTypes.shape({
    bodyStyle: PropTypes.oneOf(values(BODY_STYLES)).isRequired,
    recommendedSafetyFeaturesCount: PropTypes.shape({
      vehicle: PropTypes.number,
      total: PropTypes.number,
    }),
  }),
  ancapTestResults: PropTypes.shape({
    ancapReport: PropTypes.string,
    activeSafetyAssist: PropTypes.string,
    adultOccupantProtection: PropTypes.string,
    childOccupantProtection: PropTypes.string,
    overallScore: PropTypes.string,
    pedestrianProtection: PropTypes.string,
    vulnerableRoadUserProtection: PropTypes.string,
  }),
  ucsrTestResults: PropTypes.shape({
    primarySafety: PropTypes.number,
    driverProtection: PropTypes.number,
    aggressivity: PropTypes.number,
    saferPick: PropTypes.bool,
  }),
  footer: PropTypes.shape({
    pPlateRestrictions: PropTypes.oneOf(values(P_PLATE_RESTRICTION_STATUSES)).isRequired,
    priceRange: PropTypes.shape({ low: PropTypes.number, high: PropTypes.number }),
    newPrice: PropTypes.number,
  }),
  shouldUsePedestrianProtection: PropTypes.bool,
  vehicleEcoData: PropTypes.shape({
    powerplanttype: PropTypes.string,
    energyconsumption: PropTypes.number,
    kmrangeelectricwltp: PropTypes.number,
    greenhouserating: PropTypes.number,
    airpollutionrating: PropTypes.number,
    co2combined: PropTypes.number,
    co2urban: PropTypes.number,
    co2extraurban: PropTypes.number,
    fuelcombined: PropTypes.number,
    fuelurban: PropTypes.number,
    fuelextraurban: PropTypes.number,
    emissionstandard: PropTypes.string,
  }),
  pageVehicle: PropTypes.shape({
    transmission: PropTypes.string,
    fuelType: PropTypes.string,
  }).isRequired,
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'dispatch' implicitly has an 'any' type.
const mapDispatch = (dispatch) => ({
  actions: {
    addToCompare: dispatch.compare.addToCompare,
    openMiniCart: dispatch.ui.openMiniCart,
  },
});

export const ScorecardForTest = Scorecard;

export default connect(null, mapDispatch)(Scorecard);
